import { useQuery } from '@tanstack/react-query';
import { fetchSupplierDiagram } from './supplierDiagramApi';

export const supplierDiagramQueryKey = (diagramId) => ['supplierDiagram', diagramId];

// Backs DiagramViewPage — GET /supplier/diagrams/:diagramId (S7 item 1) so a
// param'd diagram (a draft's source diagram, an upload result) resolves
// through the tenant-scoped supplier route instead of the legacy
// GET /diagrams/:id, which 404s on supplier source-evidence diagrams.
export const useSupplierDiagram = (diagramId, { enabled = true } = {}) =>
  useQuery({
    queryKey: supplierDiagramQueryKey(diagramId),
    queryFn: () => fetchSupplierDiagram(diagramId),
    enabled: enabled && !!diagramId && diagramId !== 'new-diagram',
    staleTime: 0,
  });
